export default __webpack_public_path__ + "static/media/1.631e067b.mp3";